import { createContext, useContext } from 'react';
export const TabsContext = createContext({
    setSelectedTab: function () { },
});
export const useTabsContext = () => useContext(TabsContext);
export const TabBarContext = createContext({});
export const useTabBarContext = () => useContext(TabBarContext);
